import React from 'react';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { LegalFooterType, LegalFooterUi } from './ui';
import { LegalFooterLoadingPlaceholder } from '@cp-shared-15/frontend-ui';
import { useTranslation } from 'react-i18next';

const LegalFooterWithHandlers = withLoadingAndNoConnectionHandler(LegalFooterUi);

export const LegalFooter: React.FC = () => {
    const { t: cms } = useTranslation('footer-cms');
    const legalFooterContent: LegalFooterType = cms('content', { returnObjects: true });

    return (
        <LegalFooterWithHandlers
            isLoading={false}
            legalFooter={legalFooterContent}
            hasError={false}
            loadingPlacehloder={<LegalFooterLoadingPlaceholder />}
        />
    );
};
